import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { PRODUCT_CACHE_KEYS } from "./keys";

import { ProductRepository } from "@/repositories/product";

export const useGetProductSummary = (id: string) => {
  const productRepository = useRef(new ProductRepository());

  return useQuery({
    queryKey: PRODUCT_CACHE_KEYS.DETAIL(id),
    queryFn: () => productRepository.current.findSummary(id),
    enabled: id !== "",
  });
};
